import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const KeyHighlights = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const highlightsData = labels.menuPages?.howItWorks?.hero?.highlights || [];

  const colors = [
    "bg-green-400",
    "bg-blue-400",
    "bg-purple-400",
    "bg-pink-400",
  ];

  const highlights = highlightsData.map((text: string, index: number) => ({
    color: colors[index] || colors[0],
    text: text,
  }));

  return (
    <div className="flex flex-wrap justify-center lg:justify-start gap-4 md:gap-6 text-sm sm:text-base text-gray-300">
      {highlights.map((highlight, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className={`w-2 h-2 ${highlight.color} rounded-full`}></div>
          <span>{highlight.text}</span>
        </div>
      ))}
    </div>
  );
};

export default KeyHighlights;
